import {RecordForm} from '../forms/RecordForm';
import {useOrder} from '../hooks/useOrder.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {Order} from "../types.ts";

export const AddPage = () => {
    const { createRecord } = useOrder();

    return (
        <FormPageLayout
            title='Add Order'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as Order} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};